// extracted by mini-css-extract-plugin
export default {"backToLogin":"BackToLoginBtn_backToLogin__+GDnk"};